import { Snackbar as MuiSnackbar, type SnackbarProps as MuiSnackbarProps } from '@mui/material';
import { forwardRef } from 'react';

/**
 * FSE Snackbar — thin wrapper over MUI Snackbar for transient toasts. Pair it
 * with an `<Alert>` child for coloured success/error toasts. Exposed through
 * @fse/ui so consumers never import @mui/material directly (swap-promise).
 */
export type SnackbarProps = MuiSnackbarProps;

export const Snackbar = forwardRef<HTMLDivElement, SnackbarProps>(function Snackbar(props, ref) {
  return <MuiSnackbar ref={ref} {...props} />;
});
